import { render, staticRenderFns } from "./StaffPoints.vue?vue&type=template&id=00145e5b"
import script from "./StaffPoints.vue?vue&type=script&lang=js"
export * from "./StaffPoints.vue?vue&type=script&lang=js"
import style0 from "./StaffPoints.vue?vue&type=style&index=0&id=00145e5b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports